import BaseCrudService from "./baseCrud.service";

export default class KnowledgeBaseFaqService extends BaseCrudService {

    constructor() {
        super("KnowledgeBaseFaq");
    }

    listAllFaqs() {
        return this.getRequest("ListAll");
    }

    listByCampaignType(faqCampaignType) {
        return this.getRequest("ListByCampaignType", { faqCampaignType });
    }

    find(id) {
        return this.getRequest("FindById", { id });
    }

    // silent=true: sem loader global e sem mensagem (usado no reorder otimista).
    save(faq, silent = false) {
        return this.postRequest("Save", faq, !silent, !silent);
    }

    deleteFaq(id) {
        return this.deleteRequest("Delete", { id });
    }
}
